import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { queryPromoter } from 'store/siteConfig'
import _ from 'lodash'
import queryString from 'query-string'

// ------------------------------------
// Constants
// ------------------------------------
export const MERCHANT_PROMOTION_PROMOTER = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    SHOW_PAGE: null
  },
  'MERCHANT_PROMOTION_PROMOTER'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/activity/detail',
        body: {
          scenesCode: 'MERCHANT_PROMOTERS'
        },
        method: 'POST',
        requestAction: MERCHANT_PROMOTION_PROMOTER.INIT_REQUEST,
        successAction: MERCHANT_PROMOTION_PROMOTER.INIT_SUCCESS,
        success: function(result) {
          dispatch({
            type: MERCHANT_PROMOTION_PROMOTER.SHOW_PAGE
          })
          typeof callback === 'function' && callback()
        }
      })
    )
  }
}

export function query() {
  return (dispatch) => {
    dispatch(queryPromoter()).then((res) => {
      console.log(res.payload)
      const { commandData } = res.payload
      if (_.get(commandData, 'bizData.isPromoter') === 'Y') {
        return dispatch(init())
      }
      // 非推广员进入被邀请人流程
      const { inviteCode } = queryString.parseUrl(window.location.href).query
      return dispatch(
        replace(
          queryString.stringifyUrl({
            url: '/merchant/promotion/invitee',
            query: { inviteCode }
          })
        )
      )
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [MERCHANT_PROMOTION_PROMOTER.INIT_REQUEST]: (state, action) => state,
  [MERCHANT_PROMOTION_PROMOTER.INIT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [MERCHANT_PROMOTION_PROMOTER.SHOW_PAGE]: (state, action) =>
    Object.assign({}, state, { showPage: true })
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'merchantPromotionPromoter',
    reducerMap: {
      merchantPromotionPromoterState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
